import constantFactory from "@gaoding/constant-factory";

export const { COLOR, COLOR_LIST, COLOR_MAP, COLOR_ITEM_MAP } = constantFactory(
  "COLOR",
  [
    {
      key: "GREEN",
      label: "绿色",
      value: "green",
      color: "#B9DC5A",
      icon: "//cdn.dancf.com/fe-assets/img/2a8870047c0b4b659da0d3c5164d28c4.png",
    },
    {
      key: "YELLOW",
      label: "黄色",
      value: "yellow",
      color: "#F3DD65",
      icon: "//cdn.dancf.com/fe-assets/img/aced994d167f235ee96d31df9b63b202.png",
    },
    {
      key: "ORANGE",
      label: "橘色",
      value: "orange",
      color: "#F8A650",
      icon: "//cdn.dancf.com/fe-assets/img/2f346efb58473474ac819c83dda85038.png",
    },
    {
      key: "RED",
      label: "红色",
      value: "red",
      color: "#E86348",
      icon: "//cdn.dancf.com/fe-assets/img/254c4c652609cdc4309a6e94c95eb9bf.png",
    },
    {
      key: "BLACK",
      label: "黑色",
      value: "black",
      color: "#4D4D4D",
      icon: "//cdn.dancf.com/fe-assets/img/2853fd71b7e7d140350ff8c927bd2d20.png",
    },
    {
      key: "CYAN",
      label: "青色",
      value: "cyan",
      color: "#90C8C8",
      icon: "//cdn.dancf.com/fe-assets/img/9747d376d222797a896d7a4ab0c1b69a.png",
    },
    {
      key: "BLUE",
      label: "蓝色",
      value: "blue",
      color: "#5B99D5",
      icon: "//cdn.dancf.com/fe-assets/img/9ef3c8fadff1debc7be06bc186364449.png",
    },
    {
      key: "PURPLE",
      label: "紫色",
      value: "purple",
      color: "#7469EE",
      icon: "//cdn.dancf.com/fe-assets/img/921ee74134804f5a19e4cb36d6042c15.png",
    },
    {
      key: "BROWN",
      label: "棕色",
      value: "brown",
      color: "#965C23",
      icon: "//cdn.dancf.com/fe-assets/img/be4f4fd869f6f64ab55beb506ac3a62e.png",
    },
    {
      key: "WHITE",
      label: "白色",
      value: "white",
      color: "#FFFFFF",
      icon: "//cdn.dancf.com/fe-assets/img/6ca5da3ba00dff7e3f1efeb42d7b605f.png",
    },
    {
      key: "PINK",
      label: "粉色",
      value: "pink",
      color: "#f095c8",
      icon: "//gaoding-market.dancf.com/market-operations/market/side/4dbede92a22c42379904c3d6f5b9aa7c/1735543176222.png",
    },
  ]
);
